import { useQuery } from '@based/sdk'
import { ActiveFilterChip } from '@app/components/blocks/searchGrid/SearchGrid'
import { useTranslations } from '@i18n/useLanguage'
import { PlotFilter } from 'functions/app/plot/list/filters'
import { ListRegionModel } from 'functions/app/geography/list/region'
import { plotApplicationStatusesTranslations } from '@i18n/languages/nl.enumTranslations'
import { useMemo } from 'react'

export const usePlotFilterChips = (
  filters: PlotFilter,
  setFilters: (filters: PlotFilter) => void,
): ActiveFilterChip[] => {
  const { data: regions }: { data?: ListRegionModel[] } =
    useQuery('list-region')
  const groupLabels = useTranslations().app.discoveryPage.filterDrawer

  return useMemo(() => {
    const chips: ActiveFilterChip[] = []

    for (const id of filters.province ?? []) {
      const region = regions?.find((r) => r.id === id)
      if (!region) continue
      chips.push({
        key: `province:${id}`,
        label: `${groupLabels.province}: ${region.name}`,
        onRemove: () => {
          const next = (filters.province ?? []).filter((v) => v !== id)
          setFilters({ ...filters, province: next.length ? next : undefined })
        },
      })
    }

    for (const status of filters.applicationStatus ?? []) {
      chips.push({
        key: `applicationStatus:${status}`,
        label: `${groupLabels.applicationStatus}: ${plotApplicationStatusesTranslations[status]}`,
        onRemove: () => {
          const next = (filters.applicationStatus ?? []).filter(
            (v) => v !== status,
          )
          setFilters({
            ...filters,
            applicationStatus: next.length ? next : undefined,
          })
        },
      })
    }

    if (
      filters.byCrowdbuilding !== null &&
      filters.byCrowdbuilding !== undefined
    ) {
      chips.push({
        key: 'byCrowdbuilding',
        label: `${groupLabels.applicationType}: ${
          filters.byCrowdbuilding
            ? groupLabels.crowdBuilding
            : groupLabels.external
        }`,
        onRemove: () => setFilters({ ...filters, byCrowdbuilding: undefined }),
      })
    }

    return chips
  }, [filters, setFilters, regions, groupLabels])
}
